import { gql } from '@apollo/client';

export const SEARCH_SPONSORS = gql`
  query SEARCH_SPONSORS($sponsorSearchCriteria: SponsorSearchCriteria, $locale: String) {
    searchSponsors(criteria: $sponsorSearchCriteria, locale: $locale) {
      pagination {
        totalCount
      }
      sponsorshipLevels {
        id
        name
        rank
      }
      hasVirtualBooths
      data {
        id
        name
        location
        tagline
        logoUrl
        hasVirtualBooth
        eventSponsor
        sponsorshipLevels
        featured
      }
      categories {
        previewExhibitors {
          id
          name
          logoUrl
        }
      }
    }
  }
`;
